import { createTheme } from "@mui/material/styles";

// Layout heights root -> navbar / content
const rootHeight = "100vh";
const appNavBarHeight = "4.3rem";

// Extend module '@mui/material/styles' to add new properties
declare module "@mui/material/styles" {
  interface Theme {
    customTransitions: {
      colorTransition: string;
    };
    customLayoutHeight: {
      rootHeight: string;
      appNavBarHeight: string;
    };
  }
  interface Palette {
    customColors: {
      positiveVariationColor: string;
      negativeVariationColor: string;
      generateVideoColor: string;
      generateSummaryColor: string;
      newsPaperColor: string;
      disabledColor: string;
      mainLower: string;
      core: string;
      syntetis: string;
      nexus: string;
    };
  }
  // to work in sync with `createTheme`
  interface ThemeOptions {
    customTransitions?: {
      colorTransition?: string;
    };
    customLayoutHeight?: {
      rootHeight?: string;
      appNavBarHeight?: string;
    };
  }
  interface PaletteOptions {
    customColors?: {
      positiveVariationColor?: string;
      negativeVariationColor?: string;
      generateVideoColor?: string;
      generateSummaryColor?: string;
      newsPaperColor?: string;
      disabledColor: string;
      mainLower: string;
      core: string;
      syntetis: string;
      nexus: string;
    };
  }
}

const BaseTheme = createTheme({
  typography: {
    fontFamily: "Anton"
  },
  palette: {
    mode: "light",
    primary: {
      main: "#436257"
    },
    secondary: {
      main: "#fa6375",
      contrastText: "#ffffff"
    },
    background: {
      default: "#f7f7f7"
    },
    error: {
      main: "#ff0004"
    },
    success: {
      main: "#28a745"
    },
    customColors: {
      positiveVariationColor: "#027A48",
      negativeVariationColor: "#B42318",
      generateVideoColor: "#f3c518",
      generateSummaryColor: "#14a6d9",
      newsPaperColor: "#D8D8D8",
      disabledColor: "#a1a1a1",
      mainLower: "#2668f5",
      core: "#263530",
      syntetis: "#436257",
      nexus: "#95C4B4"
    }
  },
  shape: {
    borderRadius: 5
  },
  customTransitions: {
    colorTransition: "all 150ms ease-in-out"
  },
  customLayoutHeight: {
    rootHeight: rootHeight,
    appNavBarHeight: appNavBarHeight
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: ({ theme }) => ({
          borderRadius: 7,
          fontSize: 16,
          textTransform: "none",
          fontWeight: 600,
          backgroundColor: theme.palette.customColors.mainLower, // o theme.palette.primary.main
          "&:hover": {
            backgroundColor: theme.palette.customColors.mainLower
          }
        })
      }
    }
  }
});

export default BaseTheme;
